import { render } from "./Users.vue?vue&type=template&id=084a7f0e"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
script.render = render

export default script